export const sumKeyValues = (obj: any) => Object.keys(obj).reduce((acc, value) => acc + obj[value], 0);